import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import templateUrl from "./profile-details.html";

export const profileDetailComponent = {
  bindings: {
    details: "<",
  },
  templateUrl,
  controller: class ProfileDetailComponent {
    constructor($state, AuthService, Constants) {
      "ngInject";

      this.$state = $state;
      this.Constants = Constants;
      this.authService = AuthService;
    }
    $onInit() {
      const user = this.authService.getUser();
      const phoneUtil = PhoneNumberUtil.getInstance();
      if (this.details.phoneNumber) {
        const number = phoneUtil.parseAndKeepRawInput(
          this.details.phoneNumber,
          this.details.phoneCountryCode
        );
        this.phoneNumberFormat = phoneUtil.format(
          number,
          PhoneNumberFormat.NATIONAL
        );
      }

      this.showEditIcon =
        parseInt(user.accountId) === parseInt(this.details.accountId)
          ? true
          : false;
    }
    onEdit(id) {
      this.$state.go("profileEdit", { id });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-details/profile-details.component.js